import isString from './isString';

export default isString;
